import { type ReactElement } from 'react';
import { Sparkles } from '@/components/icons';
import { SubscriptionPlansModal } from '@/components/modals/SubscriptionPlansModal';
import { Button, type ButtonProps } from '@/components/ui/button';
import { useModalContext } from '@/components/ui/modal-provider';
import { cn } from '@/lib/utils';

type UpgradeAccountButtonProps = Omit<ButtonProps, 'children'> & {
    iconOnly?: boolean;
    labelClassName?: string;
};

export default function UpgradeAccountButton({
    iconOnly = false,
    className,
    labelClassName,
    type = 'button',
    ...props
}: UpgradeAccountButtonProps): ReactElement {
    const { openModal, closeModal } = useModalContext();

    const handleOpenPlansModal = () => {
        openModal({
            title: 'Conheça nossos planos',
            content: (
                <SubscriptionPlansModal
                    close={closeModal}
                    description="Escolha um plano para desbloquear todos os recursos da plataforma e produzir laudos com mais rapidez e segurança técnica."
                    closeLabel="Fechar"
                />
            ),
            size: 'xl',
        });
    };

    return (
        <Button
            type={type}
            variant="outline"
            onClick={handleOpenPlansModal}
            className={cn(
                'h-10 rounded-xl border-brand/15 bg-transparent px-3 text-brand shadow-none transition-[background-color,border-color,color,box-shadow,transform] duration-150 ease-out hover:bg-brand-subtle/40 hover:text-brand',
                iconOnly && 'w-10 rounded-full px-0',
                className,
            )}
            {...props}
        >
            <Sparkles className="size-4 text-brand" />
            {!iconOnly && (
                <span
                    className={cn(
                        'upgrade-sidebar-cta__label bg-clip-text text-sm font-semibold text-transparent',
                        labelClassName,
                    )}
                >
                    Upgrade
                </span>
            )}
            <span className="sr-only">Upgrade</span>
        </Button>
    );
}
